import { htmlSafe } from '@ember/template';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { round } from 'volta/utils/math-utils';

interface IArgs {
  title?: string;
  maxDemand?: number;
  demand?: number;
  onHand?: number;
  supply?: number;
  fixedWidth?: boolean;
  unitMeasure?: string
}

export default class CapacityGauge extends Component<IArgs> {
  get demandPct() {
    return this.calcPct(this.args.demand, this.args.maxDemand);
  }

  get onHandPct() {
    return this.calcPct(this.args.onHand, this.args.maxDemand);
  }

  get supplyPct() {
    return this.calcPct(this.args.supply, this.args.maxDemand);
  }

  get demandStyle() {
    return htmlSafe(this.calcHeight(this.demandPct));
  }

  get supplyStyle() {
    return htmlSafe(this.calcHeight(this.supplyPct) + this.calcBottom(this.onHandPct));
  }

  get onHandStyle() {
    return htmlSafe(this.calcHeight(this.onHandPct));
  }

  get criticalityClassName() {
    const { demand = 0, onHand = 0, supply = 0 } = this.args;

    const stock = onHand + supply;
    const diff = stock - Math.abs(demand);

    if (diff < 0) return 'capacity-gauge--high';
    else return 'capacity-gauge--low';
  }

  // Helpers
  // ~~~~~~

  calcPct(value?: number, max?: number) {
    if (!isPresent(max)) {
      return 1;
    }

    return max === 0 || !isPresent(value) ? 0 : Math.abs(value!) / Math.abs(max!);
  }

  calcHeight(value: number) {
    const height = value > 1 ? 1 : value < 0 ? 0 : value;
    return `height:${round(height, 2)! * 100.0}%;`;
  }

  calcBottom(value: number) {
    const bottom = value > 1 ? 1 : value < 0 ? 0 : value;
    return `bottom:${round(bottom, 2)! * 100.0}%;`;
  }
}
